import jsonFetch from '@cube/utils/lib/json-fetch';

// 5 minute cache age.
const MAX_AGE = 5 * 60 * 1000;

/**
 * Please keep this file as simple as possible. The `Weather API` should return raw responses.
 * If there is a need for normalization, perform that in the `Weather Client` file/module.
 */

let apiOrigin = '';

function validateApiOrigin() {
	if (!apiOrigin || !apiOrigin.length) {
		apiOriginError();
	}
}

function apiOriginError() {
	let err = `WeatherAPI ERROR: Invalid apiOrigin: ${apiOrigin}`;
	if (process.env.NODE_ENV !== 'production') {
		throw new Error(err);
	}
	else {
		console.error(err);
	}
}

function limitPrecision(latitude, longitude) {
	return [Number(latitude).toFixed(2), Number(longitude).toFixed(2)];
}


export function setApiOrigin(url) {
	if (url && url.charAt(url.length - 1) === '/') {
		url = url.substr(0, url.length - 1);
	}
	apiOrigin = url;
	validateApiOrigin();
}

export function fetchCurrentConditions(latitude, longitude) {
	[latitude, longitude] = limitPrecision(latitude, longitude);
	validateApiOrigin();
	return jsonFetch(`${apiOrigin}/current/location/${latitude},${longitude}/`, {}, MAX_AGE);
}

export function fetchAirQuality(latitude, longitude) {
	[latitude, longitude] = limitPrecision(latitude, longitude);
	validateApiOrigin();
	return jsonFetch(`${apiOrigin}/airquality/location/${latitude},${longitude}/`, {}, MAX_AGE);
}

export function fetchAlerts(latitude, longitude) {
	[latitude, longitude] = limitPrecision(latitude, longitude);
	validateApiOrigin();
	return jsonFetch(`${apiOrigin}/alerts/location/${latitude},${longitude}/`, {}, MAX_AGE);
}
